import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function LegalHeader({ title }) {

  return (
    <>
      <div className="page-header clear-filter page-header-small">
        <div>
          <Container className="d-flex align-items-center justify-content-center mb-4">
            <h1 className="title font-weight-regular">{title}</h1>
          </Container>
        </div>
      </div>
    </>
  );
}

export default LegalHeader;
